<app-popup-content>
    <div class="rename-column">
        <div class="header">
            <span class="cursor-default">{{ dictionary.t_rename_column }}</span>
            <fui-button
                (clickEvent)="close()"
                type="button-icon"
                icon="close"
                height="slim"
                color="flat"
                borderRadius="circle"
            >
            </fui-button>
        </div>

        <div class="content">
            <div (keydown.enter)="save()" class="settings-name-table-container" [formGroup]="form">
                <fui-text-input
                    [fieldGroup]="form"
                    fieldName="titleColumn"
                    [label]="dictionary.system_field_name"
                    [maxLength]="255"
                    [validationErrorService]="validationErrorService"
                ></fui-text-input>
            </div>
        </div>

        <div class="footer">
            <fui-button
                (clickEvent)="save()"
                [label]="dictionary.system_save"
                [icon]="'content-save'"
                [height]="'mini'"
                [disabled]="form.invalid"
            >
            </fui-button>
            <fui-button
                (clickEvent)="close()"
                [label]="dictionary.system_close"
                [color]="'light'"
                [icon]="'close'"
                [height]="'mini'"
            >
            </fui-button>
        </div>
    </div>
</app-popup-content>
